"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePosition = void 0;
const calculatePosition = (triggerPosition, floatingContentPosition, position, triggerParentValues) => {
    const { clientHeight, clientWidth } = document.body;
    const { x, top, bottom, left, width, height, y } = triggerPosition;
    const nextStyle = { minWidth: width };
    if (position === "left" || position === "right") {
        const floatingContentHeight = floatingContentPosition.height;
        nextStyle.bottom = top - (floatingContentHeight - height) / 2;
        if (position === "left") {
            nextStyle.right = clientWidth - x;
        }
        else {
            nextStyle.left = width + x;
        }
        return nextStyle;
    }
    if (position.includes("bottom")) {
        nextStyle.bottom = clientHeight - bottom;
        /**
         * if the floating content should consider the parent dimension, it is required to calculate the correct dimension
         * based on parent dimension
         */
        if (triggerParentValues) {
            const valueToInclude = y + height;
            nextStyle.bottom -= triggerParentValues.height - valueToInclude;
        }
        nextStyle.transform = "translate(0%, 100%)";
    }
    if (position.includes("top")) {
        nextStyle.bottom = clientHeight - top;
    }
    if (position.includes("right")) {
        nextStyle.left = left + width;
    }
    if (position.includes("center")) {
        const floatingContentWidth = floatingContentPosition.width;
        const widthCalc = (floatingContentWidth - width) / 2;
        nextStyle.left = left - widthCalc;
    }
    if (position.includes("left")) {
        nextStyle.left = left;
    }
    return nextStyle;
};
exports.calculatePosition = calculatePosition;
